export const numberValidator = value => value && isNaN(Number(value)) ? 'Must be a number' : undefined;
